import { useDispatch, useSelector } from "react-redux";
import { Auth } from "aws-amplify";
import { useEffect } from "react";
import { actions } from "./../../pages/AuthScreens/authScreens.reducers";
import { useNavigate } from "react-router-dom";
import { selectIsAuthenticated } from "../../pages/UserProfile";
import { CACHE_KEYS, ROUTES } from "../../constants";

const { ORGANIZATION } = CACHE_KEYS;
const { LOGIN, SELECT_WORKSPACE } = ROUTES;

const { setShouldShowNav } = actions;

const handleSignOut = () => {
  sessionStorage.clear();
  localStorage.clear();
};

const AmplifyAuth = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isAuthenticated = useSelector(selectIsAuthenticated);

  useEffect(() => {
    const isWorkspaceSelected = !!JSON.parse(
      sessionStorage.getItem(ORGANIZATION)
    );
    const shouldRedirectToSelectWorkspace = !isWorkspaceSelected && isAuthenticated;
    if (shouldRedirectToSelectWorkspace) {
      dispatch(setShouldShowNav(false));
      navigate(SELECT_WORKSPACE, { replace: true });
    }
  }, [dispatch, navigate, isAuthenticated]);

  if (isAuthenticated) return props.children;
  else {
    const promise = Promise.resolve(Auth.signOut());
    promise.then(() => handleSignOut()).catch((err) => console.log(err));
    return window.location.assign(LOGIN);
  }
};

export default AmplifyAuth;
